// components/InstantTranslateDemo.jsx
import React, { useState } from "react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const sentence = [
  "I",
  "have",
  "more",
  "in",
  { text: "common", fa: "مشترک، وجه اشتراک" },
  "with",
  "you",
  "than",
  "you",
  { text: "think", fa: "فکر کردن" },
  ".",
];

const InstantTranslateDemo = () => {
  const [activeIdx, setActiveIdx] = useState(null);

  const handleWordClick = (idx) => {
    setActiveIdx((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="ترجمه لحظه‌ای"
            badgeColor="purple"
            title="روی هر لغت کلیک کن، ترجمه‌ش رو فوری ببین"
            subtitle="هر لحظه از فیلم، توی زیرنویس انگلیسی روی یک لغت بزن تا معنی بیاد."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.translateDemo}>
            <div className={styles.sentence}>
              {sentence.map((word, idx) =>
                typeof word === "string" ? (
                  <span key={idx} className={styles.sentenceWord}>
                    {word}
                  </span>
                ) : (
                  <span key={idx} className={styles.wordWrap}>
                    <button
                      type="button"
                      className={`${styles.sentenceWord} ${styles.wordClickable} ${
                        activeIdx === idx ? styles.wordActive : ""
                      }`}
                      onClick={() => handleWordClick(idx)}
                    >
                      {word.text}
                    </button>
                    {activeIdx === idx && (
                      <span className={styles.tooltip}>
                        <span className={styles.tooltipText}>{word.fa}</span>
                        <span className={styles.tooltipActions}>
                          <button type="button" className={styles.saveBtn}>
                            <i className="fas fa-bookmark"></i>
                            ذخیره
                          </button>
                          <button type="button" className={styles.dictBtn}>
                            <i className="fas fa-book-open"></i>
                            دیکشنری‌ها
                          </button>
                        </span>
                        <span className={styles.tooltipArrow}></span>
                      </span>
                    )}
                  </span>
                )
              )}
            </div>

            <p className={styles.demoCaption}>
              روی هر لغت کلیک کن، ترجمه‌ش رو فوری ببین.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default InstantTranslateDemo;